// Address normalization helpers shared by the global search results page and
// the Leads page in-page filter.
//
// Mortgage data is full of US Postal directional abbreviations (W, E, N, S,
// NW, NE, SW, SE) — sometimes with periods, sometimes without, and a single
// borrower's record might have "978 West Yellowstone Way" while their next
// statement reads "978 W. Yellowstone Way". LOs shouldn't have to guess; we
// normalize both the haystack and the query so all of these match:
//
//   "W Yellowstone"   ←→  "West Yellowstone"
//   "S. Ash Ave"      ←→  "South Ash Ave"
//   "NW 4th St"       ←→  "Northwest 4th St"

const DIRS = {
  n: 'north',
  s: 'south',
  e: 'east',
  w: 'west',
  ne: 'northeast',
  nw: 'northwest',
  se: 'southeast',
  sw: 'southwest',
};

export function normalizeAddress(raw) {
  if (!raw) return '';
  return String(raw)
    .toLowerCase()
    .replace(/\./g, ' ') // "W." → "W "
    .split(/\s+/)
    .filter(Boolean)
    .map((tok) => DIRS[tok] || tok)
    .join(' ');
}

// Convenience for `includes`-style match across address fields with directional
// normalization applied to BOTH sides.
export function addressIncludes(haystack, needle) {
  if (!needle) return false;
  return normalizeAddress(haystack).includes(normalizeAddress(needle));
}

// True when the normalized haystack starts with the normalized needle.
export function addressStartsWith(haystack, needle) {
  if (!needle) return false;
  return normalizeAddress(haystack).startsWith(normalizeAddress(needle));
}
